export default "__VITE_ASSET__BdLCMbGa__"